import { render, staticRenderFns } from "./table.vue?vue&type=template&id=b81f6086&"
import script from "./table.ts?vue&type=script&lang=ts&"
export * from "./table.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports